export default __webpack_public_path__ + "static/media/blumeattempt-justlikeyou-05.33d4814e.jpg";